import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import ProgramCreateSuccessPage from '@/features/programs/program-create-success/ProgramCreateSuccessPage';

export const programCreateSuccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/novo/sucesso',
  component: ProgramCreateSuccessPage,
});
